export default __webpack_public_path__ + "locales/ro/Settings.json?hash=50c78e4003a6e8c83d055abfca3baeb3";